import DefaultForgetPassword from "src/components/feature/ForgetPassword";
const ForgetPassword = () => {
  return <DefaultForgetPassword />;
};

export default ForgetPassword;
